import { Outlet } from "react-router-dom";
import classes from "./Introduce.module.css";
import IntroduceNavigation from "./IntroduceNavigation";

function IntroduceRootLayout() {
    return (
        <div className={`container ${classes.introduce_container}`}>
            <IntroduceNavigation />
            <section>
                <div className={classes.introduce_contents}>
                    <Outlet />
                </div>
            </section>
        </div>
    );
}

export default IntroduceRootLayout;
